import { render, staticRenderFns } from "./DetailTypeGraph.vue?vue&type=template&id=32cb5a06&scoped=true&"
import script from "./DetailTypeGraph.vue?vue&type=script&lang=js&"
export * from "./DetailTypeGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb5a06",
  null
  
)

export default component.exports